<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Users</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-bars"></i>
                    <span>Users </span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container heightcls">
    <div class="well" style="height: 98%;padding-bottom: 28px !important">
        <user-list></user-list>
    </div>
</div>